__turbopack_context__.v({
  "className": "eJXkmG_className",
  "variable": "eJXkmG_variable",
});
